import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, ArrowUpCircleIcon, TrendingUpIcon, ArrowRightIcon } from 'lucide-react';
const pathways = [{
  title: 'First Home Buyers',
  description: 'Buying your first place and want to get it right from day one.',
  icon: HomeIcon,
  cta: 'Start Here',
  href: '/first-home-buyers',
  highlight: false
}, {
  title: 'Home Buyers',
  description: 'Upgrading, refinancing, or buying your next home.',
  icon: ArrowUpCircleIcon,
  cta: 'Explore Options',
  href: '/home-buyers',
  highlight: false
}, {
  title: 'Investors',
  description: 'Building or scaling a property portfolio with strategy.',
  icon: TrendingUpIcon,
  cta: 'View Strategy',
  href: '/investors',
  highlight: true
}];
export function PathwaySection() {
  return <section className="py-20 bg-white dark:bg-[#0f1629]/80 border-t border-slate-100 dark:border-white/5 transition-colors duration-300" data-id="element-303">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-304">
        <div className="text-center mb-14" data-id="element-305">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 dark:text-white mb-3" data-id="element-306">
            How Can We Help?
          </h2>
          <p className="text-lg text-slate-500 dark:text-slate-400 max-w-xl mx-auto" data-id="element-307">
            Choose your path — we'll tailor the strategy to your situation.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-308">
          {pathways.map((pathway, index) => {
          const Icon = pathway.icon;
          return <Link key={index} to={pathway.href} className={`group relative p-8 rounded-2xl border transition-all duration-300 flex flex-col items-center text-center ${pathway.highlight ? 'bg-gradient-to-b from-primary-50 to-white dark:from-primary-900/20 dark:to-[#1a2035] border-primary-200 dark:border-primary-500/30 shadow-lg shadow-primary-500/10 dark:shadow-primary-500/5 md:scale-105' : 'bg-white dark:bg-[#1a2035] border-slate-200 dark:border-white/5 shadow-sm hover:shadow-md dark:shadow-none hover:border-slate-300 dark:hover:border-white/10'}`} data-id="element-309">
                {pathway.highlight && <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full bg-gradient-to-r from-accent-500 to-primary-500 text-white text-xs font-semibold shadow-md" data-id="element-310">
                    Most Popular
                  </div>}

                <div className={`p-4 rounded-2xl mb-6 transition-colors ${pathway.highlight ? 'bg-primary-100 dark:bg-primary-500/20 text-primary-600 dark:text-primary-400' : 'bg-slate-100 dark:bg-white/5 text-slate-500 dark:text-slate-400 group-hover:bg-primary-50 dark:group-hover:bg-primary-500/10 group-hover:text-primary-600 dark:group-hover:text-primary-400'}`} data-id="element-311">
                  <Icon className="w-8 h-8" data-id="element-312" />
                </div>

                <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3" data-id="element-313">
                  {pathway.title}
                </h3>
                <p className="text-slate-500 dark:text-slate-400 mb-6 leading-relaxed text-sm" data-id="element-314">
                  {pathway.description}
                </p>

                <span className={`inline-flex items-center gap-1.5 text-sm font-semibold mt-auto ${pathway.highlight ? 'text-primary-600 dark:text-primary-400' : 'text-slate-600 dark:text-slate-300 group-hover:text-primary-600 dark:group-hover:text-primary-400'} transition-colors`} data-id="element-315">
                  {pathway.cta}
                  <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-316" />
                </span>
              </Link>;
        })}
        </div>
      </div>
    </section>;
}